import _ from 'lodash';
export const normalizePlan = (plan) => {
  if (!plan || typeof plan !== 'object') return null
  return{
    id: plan.id,
    product_id: plan.product_id ?? null,
    title: plan.product_title?? "",
    sequence: plan.sequence != null ? Number(plan.sequence) : null,
    description_en: plan.description?.en ?? "",
    description_jp: plan.description?.jp ?? "",
    priceId: plan.product_price_id ?? null,
    status: plan.status ?? "active",
    label_en: plan.label?.en ?? "",
    label_jp: plan.label?.jp ?? "",

    price:
      plan.price?.product_price != null
        ? Number(plan.price.product_price)
        : null,

    currency: plan.price?.currency ?? "usd",
    interval: plan.price?.recurring_interval ?? "month",
    billingType: plan.price?.billing_type ?? "recurring",
    billingScheme: plan.price?.billing_scheme ?? "per_unit",

    features: Object.entries(plan.features ?? {}).map(([key, value]) => ({
      key,
      enabled: !!value?.enabled,
      description_en: value?.description?.en ?? "",
      description_jp: value?.description?.jp ?? "",
      sequence:value?.sequence != null ? Number(value.sequence) : null,
    })),

    createdAt: plan.created_at,
  }
};

export const serializePlan = (plan) => {
  const features = (plan.features || []).reduce((acc, feature) => {
    const featureName = String(feature.key || "").trim();

    if (!featureName) return acc;

    acc[featureName] = {
      enabled: !!feature.enabled,
      description: {
        en: feature.description_en ?? "",
        jp: feature.description_jp ?? "",
      },
      sequence: Number(feature.sequence ?? 1),
    };

    return acc;
  }, {});

  return {
    product_id: plan.product_id ?? null,
    product_title:plan.title ?? "",
    sequence: Number(plan.sequence ?? null),
    description: {
      en: plan.description_en ?? "",
      jp: plan.description_jp ?? "",
    },
    product_price_id: plan.priceId ?? null,
    status: plan.status ?? "active",
    label: {
      en: plan.label_en ?? "",
      jp: plan.label_jp ?? "",
    },
    price: {
      product_price: Number(plan.price ?? null),
      currency: plan.currency ?? "usd",
      recurring_interval: plan.interval ?? "month",
      billing_type: plan.billingType ?? "recurring",
      billing_scheme: plan.billingScheme ?? "per_unit",
    },
    features,
  };
};

export const createEmptyPlanForm = () => ({
  product_id: null,
  title: "",
  sequence: null,
  description_en: "",
  description_jp: "",
  priceId: null,
  status: "active",
  label_en: "",
  label_jp: "",
  price: null,
  currency: "usd",
  interval: "month",
  billingType: "recurring",
  billingScheme: "per_unit",
  features: [],
  createdAt: null,  
});

export const clonePlanForm = (data = {}) =>
  _.cloneDeep({
    ...createEmptyPlanForm(),
    ...data,
    features: Array.isArray(data.features) ? data.features : [],
  });

export function formatPrice(value, currency = "USD") {
  if (value == null) return "-";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(value);
}